import { generateLabReport, updateBatchNo, updateLabresults, updateTestProcess } from '@app/api/labs.api';
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  Typography,
  Button,
  Divider,
  Checkbox,
  DatePicker,
  InputNumber,
  Radio,
  Select,
  TimePicker,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { notificationController } from '@app/controllers/notificationController';
import LabWorkflowButtons from './LabWorkflowButtons';
import { UpdateTestProcessResponse } from '@app/models/labs/LabRequest';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import useApiErrorHandler from '@app/components/Error/ErrorMsgHandling';
import DocumentUpload from './DocResultUpload';

const { Title, Text } = Typography;

interface ResultsModalProps {
  visible: boolean;
  testName: string;
  resultParameters?: any;
  onClose: () => void;
  lab_id?: number | null;
  deptId?: number | null;
  mode?: 'add' | 'edit' | 'view';
  status?: string | null;
  wf_actions: any[];
  service_cat_id?: number | null;
  onTestUpdated?: (updatedTests: any[]) => void;
}

const ResultsModal: React.FC<ResultsModalProps> = ({
  visible,
  testName,
  onClose,
  resultParameters,
  mode,
  lab_id,
  deptId,
  status,
  wf_actions,
  service_cat_id,
  onTestUpdated,
}) => {
  console.log(` Serv cat: `, resultParameters);
  const [form] = Form.useForm();
  const isViewMode = mode === 'view';
  const [isLoading, setLoading] = useState(false);
  const [workflowLoading, setWorkflowLoading] = React.useState(false);
  const selectedLabType = localStorage.getItem('selected_lab_type');
  const handleErrorMessages = useApiErrorHandler();
  const [batchQty, setBatchQty] = useState('');
  const serviceCatId = resultParameters?.lab_request_service_category_id;
  const resultFormat = resultParameters?.result_format || 'FOR_SAMPLE';
  const isDocumentFormat = resultParameters?.has_test_result_attachment;
  //const isDocumentFormat = true;
  console.log('Passed batches_qty check: ', resultParameters);
  console.log('has attatchment check: ', isDocumentFormat);
  useEffect(() => {
    if (visible && resultParameters?.lab_request_services) {
      const initialValues: Record<string, any> = {};

      resultParameters.lab_request_services.forEach((service: any) => {
        const serviceId = service.id;
        const flatParams = service.lab_request_service_parameter?.result_parameters?.flat() || [];
        const otherParams = service.lab_request_service_parameter?.other_parameters || [];

        if (service.batches_qty !== undefined && service.batches_qty !== null) {
          initialValues.batch_quantity = service.batches_qty.toString();
        }

        if (selectedLabType === 'VACCINE_MANUFACTURING' || selectedLabType === 'DIRECT_SALES') {
          // For these lab types, use the simplified key format without sample grouping
          const fieldIdRenderCount: Record<string, number> = {};
          flatParams.forEach((param: any) => {
            fieldIdRenderCount[param.field_id] = (fieldIdRenderCount[param.field_id] || 0) + 1;
            const index = fieldIdRenderCount[param.field_id];
            const formKey = `${serviceId}_${param.field_id}_${index}_value`;

            if (param.value !== undefined && param.value !== null && param.value !== '') {
              let processedValue = param.value;

              if (param.input_type === 'DATE' && typeof param.value === 'string') {
                processedValue = moment(param.value, 'YYYY-MM-DD');
                if (!processedValue.isValid()) {
                  processedValue = undefined;
                }
              } else if (param.input_type === 'TIME' && typeof param.value === 'string') {
                processedValue = moment(param.value, 'HH:mm');
                if (!processedValue.isValid()) {
                  processedValue = undefined;
                }
              } else if (param.input_type === 'DATE_TIME' && typeof param.value === 'string') {
                processedValue = moment(param.value, 'YYYY-MM-DD HH:mm');
                if (!processedValue.isValid()) {
                  processedValue = undefined;
                }
              } else if (param.input_type === 'DATE_RANGE' && Array.isArray(param.value) && param.value.length === 2) {
                // Handle DATE_RANGE type
                processedValue = [
                  moment(param.value[0]).isValid() ? moment(param.value[0]) : null,
                  moment(param.value[1]).isValid() ? moment(param.value[1]) : null,
                ].filter(Boolean);
                // If we don't have valid dates, set to undefined
                if (processedValue.length !== 2) {
                  processedValue = undefined;
                }
              }

              if (processedValue !== undefined) {
                initialValues[formKey] = processedValue;
              }
            }
          });
        } else {
          // Group parameters by sample
          const paramsBySample: Record<string, any[]> = {};
          flatParams.forEach((param: any) => {
            const sampleKey = param.sample || 'default';
            if (!paramsBySample[sampleKey]) {
              paramsBySample[sampleKey] = [];
            }
            paramsBySample[sampleKey].push(param);
          });

          // Process each sample group
          Object.entries(paramsBySample).forEach(([sample, params]) => {
            const fieldIdRenderCount: Record<string, number> = {};
            params.forEach((param: any) => {
              fieldIdRenderCount[param.field_id] = (fieldIdRenderCount[param.field_id] || 0) + 1;
              const index = fieldIdRenderCount[param.field_id];
              const formKey = `${serviceId}_${param.field_id}_${sample}_${index}_value`;

              if (param.value !== undefined && param.value !== null && param.value !== '') {
                let processedValue = param.value;

                if (param.input_type === 'DATE' && typeof param.value === 'string') {
                  processedValue = moment(param.value, 'YYYY-MM-DD');
                  if (!processedValue.isValid()) {
                    processedValue = undefined;
                  }
                } else if (param.input_type === 'TIME' && typeof param.value === 'string') {
                  processedValue = moment(param.value, 'HH:mm');
                  if (!processedValue.isValid()) {
                    processedValue = undefined;
                  }
                } else if (param.input_type === 'DATE_TIME' && typeof param.value === 'string') {
                  processedValue = moment(param.value, 'YYYY-MM-DD HH:mm');
                  if (!processedValue.isValid()) {
                    processedValue = undefined;
                  }
                } else if (
                  param.input_type === 'DATE_RANGE' &&
                  Array.isArray(param.value) &&
                  param.value.length === 2
                ) {
                  // Handle DATE_RANGE type
                  processedValue = [
                    moment(param.value[0]).isValid() ? moment(param.value[0]) : null,
                    moment(param.value[1]).isValid() ? moment(param.value[1]) : null,
                  ].filter(Boolean);
                  // If we don't have valid dates, set to undefined
                  if (processedValue.length !== 2) {
                    processedValue = undefined;
                  }
                }

                if (processedValue !== undefined) {
                  initialValues[formKey] = processedValue;
                }
              }
            });
          });
        }

        otherParams.forEach((param: any, idx: number) => {
          const formKey = `${serviceId}_other_${idx}`;
          if (param.value !== undefined && param.value !== null && param.value !== '') {
            initialValues[formKey] = param.value;
          }
        });
      });

      if (
        resultParameters.remarks !== undefined &&
        resultParameters.remarks !== null &&
        resultParameters.remarks !== ''
      ) {
        initialValues.remarks = resultParameters.remarks;
      } else {
        initialValues.remarks = '';
      }

      if (
        resultParameters.results_remarks !== undefined &&
        resultParameters.results_remarks !== null &&
        resultParameters.results_remarks !== ''
      ) {
        initialValues.results_remarks = resultParameters.results_remarks;
      } else {
        initialValues.results_remarks = '';
      }

      form.setFieldsValue(initialValues);
      const firstService = resultParameters.lab_request_services[0];
      if (firstService?.batches_qty !== undefined && firstService?.batches_qty !== null) {
        setBatchQty(firstService.batches_qty.toString());
      }
    }
  }, [visible, resultParameters, form]);

  const handleFinish = async (values: any) => {
    if (isViewMode) {
      onClose();
      return;
    }
    const lab_request_services: any[] = [];

    resultParameters?.lab_request_services?.forEach((service: any) => {
      const serviceId = service.id;
      const flatParams = service.lab_request_service_parameter?.result_parameters?.flat() || [];
      const otherParams = service.lab_request_service_parameter?.other_parameters || [];

      // --- Build grouped result_parameters ---
      const groupedResultParameters: any[][] = [];

      if (selectedLabType === 'VACCINE_MANUFACTURING' || selectedLabType === 'DIRECT_SALES') {
        // Group parameters by field_id to get unique parameter definitions
        const uniqueParams: Record<string, any> = {};
        flatParams.forEach((param: any) => {
          if (!uniqueParams[param.field_id]) {
            uniqueParams[param.field_id] = param;
          }
        });

        // Count occurrences of each field_id to determine quantities
        const paramCounts: Record<string, number> = {};
        flatParams.forEach((param: any) => {
          paramCounts[param.field_id] = (paramCounts[param.field_id] || 0) + 1;
        });

        // Find the maximum quantity to determine how many sets we need
        const maxQuantity = Math.max(...Object.values(paramCounts));

        // For each set (quantity instance), collect all field values
        for (let setIndex = 0; setIndex < maxQuantity; setIndex++) {
          const setParameters: any[] = [];

          Object.entries(uniqueParams).forEach(([fieldId, param]) => {
            const quantity = paramCounts[fieldId] || 1;

            // Only include this field if it should appear in this set
            if (setIndex < quantity) {
              const formKey = `${serviceId}_${fieldId}_${setIndex + 1}_value`;
              let value = values[formKey] ?? '';

              // Convert moment objects back to strings for submission
              if (value && typeof value === 'object' && value._isAMomentObject) {
                if (param.input_type === 'DATE') {
                  value = value.format('YYYY-MM-DD');
                } else if (param.input_type === 'TIME') {
                  value = value.format('HH:mm');
                } else if (param.input_type === 'DATE_TIME') {
                  value = value.format('YYYY-MM-DD HH:mm');
                }
              } else if (param.input_type === 'DATE_RANGE' && Array.isArray(value) && value.length === 2) {
                value = value.map((date: any) => {
                  if (date && typeof date === 'object' && date._isAMomentObject) {
                    return date.toISOString();
                  }
                  return date?.toISOString?.() || date;
                });
              }

              setParameters.push({
                value,
                field_id: fieldId,
              });
            }
          });

          if (setParameters.length > 0) {
            groupedResultParameters.push(setParameters);
          }
        }
      } else {
        // Group by sample (original logic)
        const paramsBySample: Record<string, any[]> = {};
        flatParams.forEach((param: any) => {
          const sampleKey = param.sample || 'default';
          if (!paramsBySample[sampleKey]) {
            paramsBySample[sampleKey] = [];
          }
          paramsBySample[sampleKey].push(param);
        });

        // Process each sample group
        Object.entries(paramsBySample).forEach(([sample, sampleParams]) => {
          // Group parameters by field_id to get unique parameter definitions
          const uniqueParams: Record<string, any> = {};
          sampleParams.forEach((param: any) => {
            if (!uniqueParams[param.field_id]) {
              uniqueParams[param.field_id] = param;
            }
          });

          // Count occurrences of each field_id to determine quantities
          const paramCounts: Record<string, number> = {};
          sampleParams.forEach((param: any) => {
            paramCounts[param.field_id] = (paramCounts[param.field_id] || 0) + 1;
          });

          // Find the maximum quantity to determine how many sets we need
          const maxQuantity = Math.max(...Object.values(paramCounts));

          // For each set (quantity instance), collect all field values for this sample
          for (let setIndex = 0; setIndex < maxQuantity; setIndex++) {
            const setParameters: any[] = [];

            Object.entries(uniqueParams).forEach(([fieldId, param]) => {
              const quantity = paramCounts[fieldId] || 1;
              // Only include this field if it should appear in this set
              if (setIndex < quantity) {
                const formKey = `${serviceId}_${fieldId}_${sample}_${setIndex + 1}_value`;
                let value = values[formKey] ?? '';

                // Convert moment objects back to strings for submission
                if (value && typeof value === 'object' && value._isAMomentObject) {
                  if (param.input_type === 'DATE') {
                    value = value.format('YYYY-MM-DD');
                  } else if (param.input_type === 'TIME') {
                    value = value.format('HH:mm');
                  } else if (param.input_type === 'DATE_TIME') {
                    value = value.format('YYYY-MM-DD HH:mm');
                  }
                } else if (param.input_type === 'DATE_RANGE' && Array.isArray(value) && value.length === 2) {
                  // Handle DATE_RANGE conversion - convert moment objects to ISO strings
                  value = value.map((date: any) => {
                    if (date && typeof date === 'object' && date._isAMomentObject) {
                      return date.toISOString();
                    }
                    return date?.toISOString?.() || date;
                  });
                }

                setParameters.push({
                  value,
                  field_id: fieldId,
                });
              }
            });

            if (setParameters.length > 0) {
              groupedResultParameters.push(setParameters);
            }
          }
        });
      }

      // --- Build other_parameters ---
      const other_parameters = otherParams.map((param: any, idx: number) => ({
        value: values[`${serviceId}_other_${idx}`] ?? '',
        field_id: param.field_id,
      }));

      lab_request_services.push({
        lab_request_service_id: serviceId,
        result_parameters: groupedResultParameters,
        other_parameters,
      });
    });

    const payload = {
      lab_request_services,
      remarks: values.remarks ?? '',
      results_remarks: values.results_remarks,
    };

    try {
      setLoading(true);
      await updateLabresults(Number(lab_id), Number(deptId), Number(serviceCatId), payload);
      console.log(`Submitted results: `, JSON.stringify(payload, null, 2));
    } catch (err) {
      console.error(`Failed to update results`, err);
      handleErrorMessages(err);
    } finally {
      setLoading(false);
    }

    onClose();
  };

  const handleModalClose = () => {
    form.resetFields();
    onClose();
  };

  const handleBatchQtySubmit = async (serviceId: any) => {
    if (!batchQty || batchQty.trim() === '') {
      notificationController.error({
        message: 'Batch quantity is required',
        description: 'Please enter a valid batch quantity before submitting.',
      });
      return;
    }

    const batchData = {
      lab_request_services: [
        {
          lab_request_service_id: serviceId,
          batches_qty: parseInt(batchQty),
        },
      ],
    };

    console.log('About to make API call with:', batchData);

    try {
      setLoading(true);
      await updateBatchNo(Number(lab_id), Number(deptId), Number(serviceCatId), batchData);
      console.log('Submitted batch quantity:', JSON.stringify(batchData, null, 2));
      setBatchQty('');
      notificationController.success({
        message: 'Batch quantity updated successfully',
        description: `Batch quantity for service ID ${serviceId} has been updated.`,
      });
      handleModalClose();
    } catch (err) {
      console.error('Failed to update batch quantity', err);
      handleErrorMessages(err);
    } finally {
      setLoading(false);
    }
  };

  const serv_cat = resultParameters.lab_request_service_category_id;

  const handleActionClick = async (lab_id: number, deptId: number, serv_cat: number, action: string) => {
    setWorkflowLoading(true);

    try {
      if (!lab_id || !deptId || !serv_cat) {
        console.log('ids passed: ', lab_id, deptId, serv_cat);
        throw new Error('Missing required parameters: lab_id, deptId, or lab_request_service_category_id');
      }

      console.log('Executing workflow action:', { lab_id, deptId, serv_cat, action });

      const response = (await updateTestProcess(lab_id, deptId, serv_cat, {
        action,
      })) as UpdateTestProcessResponse;

      if (response && response.data) {
        notificationController.success({
          message: response.message || `Test updated successfully`,
        });

        if (response.data.lab_request_service_category) {
          const updatedCategory = response.data.lab_request_service_category;

          console.log('Workflow response data:', updatedCategory);

          const updatedTestData = {
            lab_request_service_category_id: updatedCategory.id,
            id: updatedCategory.lab_service_category?.id || updatedCategory.lab_service_category_id,
            code: updatedCategory.lab_service_category?.code || '',
            name: updatedCategory.lab_service_category?.name || '',
            user_id: updatedCategory.user_id ? 'ADMIN' : 'Unassigned',
            status:
              selectedLabType === 'DIRECT_SALES'
                ? updatedCategory.status_label || {
                    step_one: null,
                    step_two: null,
                    step_three: null,
                  }
                : updatedCategory.test_statuses || {
                    step_one: null,
                    step_two: null,
                    step_three: null,
                  },
            status_label_ds: updatedCategory.status_label || updatedCategory.status_label_ds,
            type: updatedCategory.lab_service_category?.type || '',
          };

          console.log('Sending updated test data to parent:', updatedTestData);

          if (onTestUpdated) {
            onTestUpdated([updatedTestData]);
          }

          setTimeout(() => {
            handleModalClose();
          }, 200);
        } else {
          handleModalClose();
        }
      }
    } catch (err: any) {
      console.error('Workflow action error:', err);

      handleErrorMessages(err);
    } finally {
      setWorkflowLoading(false);
    }
  };

  const createSafeMomentRange = (value: any): [moment.Moment, moment.Moment] | undefined => {
    console.log('Processing DATE_RANGE value:', value);

    if (!value || !Array.isArray(value) || value.length !== 2) {
      return undefined;
    }

    try {
      // Handle different value types
      const dates = value.map((dateValue: any) => {
        // If it's already a moment object, return it
        if (moment.isMoment(dateValue)) {
          return dateValue;
        }

        // If it's a dayjs object, convert to moment
        if (dateValue && typeof dateValue === 'object' && dateValue.$d) {
          return moment(dateValue.$d);
        }

        // If it's a string or Date object, create moment
        return moment(dateValue);
      });

      if (!dates[0].isValid() || !dates[1].isValid()) {
        console.warn('Invalid dates in range:', value);
        return undefined;
      }

      console.log('Created valid moment range:', dates);
      return [dates[0], dates[1]] as [moment.Moment, moment.Moment];
    } catch (error) {
      console.error('Error creating moment range:', error);
      return undefined;
    }
  };

  const renderFieldComponent = (param: any, isReadOnly: boolean, setIndex: number, serviceId: string) => {
    const commonProps = {
      style: { width: '100%' },
      disabled: isReadOnly,
      size: 'small' as const,
      placeholder: 'Enter result',
    };
    const { RangePicker } = DatePicker;

    const typeMap = {
      STRING: <Input readOnly={isReadOnly} {...commonProps} />,
      NUMBER: <InputNumber {...commonProps} />,
      TEXTAREA: <Input.TextArea rows={2} readOnly={isReadOnly} {...commonProps} />,
      DATE: (
        <DatePicker
          {...commonProps}
          format="YYYY-MM-DD"
          getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
        />
      ),
      TIME: (
        <TimePicker
          {...commonProps}
          format="HH:mm"
          getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
        />
      ),
      DATE_TIME: (
        <DatePicker
          {...commonProps}
          showTime
          format="YYYY-MM-DD HH:mm"
          getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
        />
      ),
      DATE_RANGE: (
        <RangePicker
          {...commonProps}
          picker="date"
          format="YYYY-MM-DD"
          value={createSafeMomentRange(param.value)}
          getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
          placeholder={['Start date', 'End date']}
        />
      ),
      SELECTION: (
        <Select {...commonProps} getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}>
          {(param.options || []).map((opt: any, index: number) => {
            const value = typeof opt === 'string' ? opt : opt.value || opt.id;
            const label =
              typeof opt === 'string'
                ? opt.trim()
                : opt.label || opt.name || opt.text || opt.title || opt.value || opt.id;

            return (
              <Select.Option key={value || index} value={value}>
                {label}
              </Select.Option>
            );
          })}
        </Select>
      ),
      CHECKBOX: <Checkbox disabled={isReadOnly} />,
      RADIO: (
        <Radio.Group disabled={isReadOnly}>
          {(param.options || []).map((opt: any, index: number) => {
            const value = typeof opt === 'string' ? opt : opt.value || opt.id;
            const label =
              typeof opt === 'string'
                ? opt.trim()
                : opt.label || opt.name || opt.text || opt.title || opt.value || opt.id;

            return (
              <Radio key={value || index} value={value}>
                {label}
              </Radio>
            );
          })}
        </Radio.Group>
      ),
      // Fallback
      DEFAULT: <Input readOnly={isReadOnly} {...commonProps} />,
    };

    return typeMap[param.input_type as keyof typeof typeMap] || typeMap.DEFAULT;
  };

  return (
    <Modal
      open={visible}
      // title={`${testName}${isViewMode ? ' (View Only)' : ''}`}
      title={testName}
      onCancel={onClose}
      footer={null}
      centered
      width={900}
      bodyStyle={{ maxHeight: 900, overflowY: 'auto', paddingRight: 16 }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 8,
          marginBottom: 16,
          paddingBottom: 8,
          borderBottom: '1px solid #f0f0f0',
        }}
      >
        <LabWorkflowButtons
          type={'result'}
          wf_actions={wf_actions}
          currentMode={'view'}
          onActionClick={(action) => handleActionClick(lab_id!, deptId!, serv_cat!, action)}
          loading={workflowLoading}
          disabled={isLoading}
          status={status}
        />
      </div>

      <Form form={form} layout="vertical" onFinish={handleFinish}>
        {isDocumentFormat && (
          <div style={{ marginBottom: 32 }}>
            <DocumentUpload
              isViewMode={isViewMode}
              labId={lab_id}
              deptId={deptId}
              resultParameters={resultParameters}
            />
          </div>
        )}

        {!isDocumentFormat && (
          <>
            {resultParameters?.lab_request_services?.map((service: any) => {
              const labService = service.lab_service;
              const parameters = service.lab_request_service_parameter?.result_parameters || [];
              const otherParams = service.lab_request_service_parameter?.other_parameters || [];

              return (
                <div key={service.id} style={{ marginBottom: 32 }}>
                  <Title level={5}>
                    {labService?.name}{' '}
                    <Text style={{ fontSize: '14px' }} type="secondary">
                      ({labService?.code})
                    </Text>
                  </Title>
                  {selectedLabType === 'VACCINE_MANUFACTURING' && (
                    <Row gutter={8} style={{ marginBottom: 24 }}>
                      <Col span={12}>
                        <Form.Item
                          label="Enter Batch Qty"
                          name="batch_quantity"
                          rules={[{ required: true, message: 'Please enter batch quantity' }]}
                          style={{ marginBottom: 0 }}
                        >
                          <Input
                            placeholder="Batch Quantity"
                            size="small"
                            value={batchQty}
                            onChange={(e) => setBatchQty(e.target.value)}
                            type="number"
                            disabled={isViewMode}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label=" " colon={false} style={{ marginBottom: 0 }}>
                          <Button
                            type="primary"
                            onClick={() => handleBatchQtySubmit(service.id)}
                            size="small"
                            style={{ marginTop: 2 }}
                            loading={isLoading}
                            disabled={!batchQty || batchQty.trim() === '' || isViewMode}
                          >
                            Submit
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  )}

                  {(() => {
                    const flatParams = parameters.flat();

                    if (selectedLabType === 'DIRECT_SALES' && flatParams.length === 0) {
                      return (
                        <Row gutter={[16, 8]}>
                          <Col span={24}>
                            <br />
                            <Text type="secondary" style={{ fontSize: '18px' }}>
                              No additional details collected here.
                            </Text>
                          </Col>
                        </Row>
                      );
                    }
                    // don't group by sample
                    if (selectedLabType === 'VACCINE_MANUFACTURING') {
                      // Group parameters by field_id to get unique parameter definitions
                      const uniqueParams: Record<string, any> = {};
                      flatParams.forEach((param: any) => {
                        if (!uniqueParams[param.field_id]) {
                          uniqueParams[param.field_id] = param;
                        }
                      });

                      // Count occurrences of each field_id to determine quantities
                      const paramCounts: Record<string, number> = {};
                      flatParams.forEach((param: any) => {
                        paramCounts[param.field_id] = (paramCounts[param.field_id] || 0) + 1;
                      });

                      const renderElements: JSX.Element[] = [];
                      const uniqueParamsList = Object.values(uniqueParams);

                      // Find the maximum quantity to determine how many sets we need
                      const maxQuantity = Math.max(...Object.values(paramCounts));

                      // Render each set (quantity instance)
                      for (let setIndex = 0; setIndex < maxQuantity; setIndex++) {
                        // Add a visual separator between sets (except for the first set)
                        if (selectedLabType === 'VACCINE_MANUFACTURING') {
                          renderElements.push(
                            <Col span={24} key={`batch_header_${setIndex}`}>
                              <div
                                style={{
                                  marginBottom: 16,
                                  marginTop: setIndex > 0 ? 24 : 0,
                                  padding: '8px 12px',
                                  backgroundColor: '#f5f5f5',
                                  borderRadius: '4px',
                                  border: '1px solid #d9d9d9',
                                }}
                              >
                                <Text strong style={{ fontSize: '14px', color: '#1890ff' }}>
                                  Batch {setIndex + 1}
                                </Text>
                              </div>
                            </Col>,
                          );
                        } else {
                          // Add a visual separator between sets for non-vaccine types (except for the first set)
                          if (setIndex > 0) {
                            renderElements.push(
                              <Col span={24} key={`separator_${setIndex}`}>
                                <div style={{ height: 16 }} />
                              </Col>,
                            );
                          }
                        }
                        // Process parameters for this set in pairs (2 columns)
                        for (let i = 0; i < uniqueParamsList.length; i++) {
                          const param = uniqueParamsList[i];
                          const paramQuantity = paramCounts[param.field_id] || 0;
                          const showParam = setIndex < paramQuantity;

                          if (showParam) {
                            // Main field
                            renderElements.push(
                              <Col span={12} key={`param_${setIndex}_${i}_main`}>
                                <Row gutter={8} align="middle">
                                  <Col flex="auto">
                                    <Form.Item
                                      label={`${setIndex + 1}. ${param.name}`}
                                      name={`${service.id}_${param.field_id}_${setIndex + 1}_value`}
                                      style={{ marginBottom: 8 }}
                                      rules={[{ required: !isViewMode, message: 'This field is required' }]}
                                      valuePropName={param.input_type === 'CHECKBOX' ? 'checked' : 'value'}
                                    >
                                      {renderFieldComponent(param, isViewMode, setIndex, service.id)}
                                    </Form.Item>
                                  </Col>
                                  {param.uom && (
                                    <Col>
                                      <Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
                                        {param.uom}
                                      </Text>
                                    </Col>
                                  )}
                                </Row>
                              </Col>,
                            );
                          }
                        }
                      }

                      return <Row gutter={[16, 8]}>{renderElements}</Row>;
                    }

                    // For other lab types, group by sample
                    const paramsBySample: Record<string, any[]> = {};
                    flatParams.forEach((param: any) => {
                      const sampleKey = param.sample || 'default';
                      if (!paramsBySample[sampleKey]) {
                        paramsBySample[sampleKey] = [];
                      }
                      paramsBySample[sampleKey].push(param);
                    });

                    return Object.entries(paramsBySample).map(([sample, sampleParams], sampleIndex) => {
                      // Group parameters by field_id to get unique parameter definitions
                      const uniqueParams: Record<string, any> = {};
                      sampleParams.forEach((param: any) => {
                        if (!uniqueParams[param.field_id]) {
                          uniqueParams[param.field_id] = param;
                        }
                      });

                      // Count occurrences of each field_id to determine quantities
                      const paramCounts: Record<string, number> = {};
                      sampleParams.forEach((param: any) => {
                        paramCounts[param.field_id] = (paramCounts[param.field_id] || 0) + 1;
                      });

                      const renderElements: JSX.Element[] = [];
                      const uniqueParamsList = Object.values(uniqueParams);
                      const sampleNumber = sampleIndex + 1; // Sample-based numbering

                      // Find the maximum quantity to determine how many sets we need
                      const maxQuantity = Math.max(...Object.values(paramCounts));

                      // Render each set (quantity instance)
                      for (let setIndex = 0; setIndex < maxQuantity; setIndex++) {
                        // Add a visual separator between sets (except for the first set)
                        if (setIndex > 0) {
                          renderElements.push(
                            <Col span={24} key={`separator_${sample}_${setIndex}`}>
                              <div style={{ height: 16 }} />
                            </Col>,
                          );
                        }

                        // Process parameters for this set in pairs (2 columns)
                        for (let i = 0; i < uniqueParamsList.length; i++) {
                          const param = uniqueParamsList[i];
                          const paramQuantity = paramCounts[param.field_id] || 0;
                          const showParam = setIndex < paramQuantity;

                          if (showParam) {
                            const serviceResultFormat = resultFormat;
                            const shouldShowNumbering = serviceResultFormat !== 'FOR_TEST';
                            // Main field
                            renderElements.push(
                              <Col span={12} key={`param_${sample}_${setIndex}_${i}_main`}>
                                <Row gutter={8} align="middle">
                                  <Col flex="auto">
                                    <Form.Item
                                      label={shouldShowNumbering ? `${sampleNumber}. ${param.name}` : param.name}
                                      name={`${service.id}_${param.field_id}_${sample}_${setIndex + 1}_value`}
                                      style={{ marginBottom: 8 }}
                                      rules={[{ required: !isViewMode, message: 'This field is required' }]}
                                      valuePropName={param.input_type === 'CHECKBOX' ? 'checked' : 'value'}
                                    >
                                      {renderFieldComponent(param, isViewMode, setIndex, service.id)}
                                    </Form.Item>
                                  </Col>
                                  {param.uom && (
                                    <Col>
                                      <Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
                                        {param.uom}
                                      </Text>
                                    </Col>
                                  )}
                                </Row>
                              </Col>,
                            );
                          }
                        }
                      }

                      return (
                        <div key={`sample_${sample}`} style={{ marginBottom: 24 }}>
                          <div
                            style={{
                              marginBottom: 16,
                              padding: '8px 12px',
                              backgroundColor: '#f5f5f5',
                              borderRadius: '4px',
                              border: '1px solid #d9d9d9',
                            }}
                          >
                            <Text strong style={{ fontSize: '14px', color: '#1890ff' }}>
                              {sample !== 'default' ? sample : 'All Sample Results'}
                            </Text>
                          </div>

                          {/* Parameters for this sample */}
                          <Row gutter={[16, 8]}>{renderElements}</Row>
                        </div>
                      );
                    });
                  })()}

                  {otherParams.length > 0 && (
                    <>
                      <Row gutter={[16, 8]}>
                        {otherParams.map((param: any, index: number) => (
                          <Col span={24} key={`${service.id}_other_${index}`}>
                            <Row gutter={8} align="middle">
                              <Col flex="auto">
                                <Form.Item
                                  label={param.name}
                                  name={`${service.id}_other_${index}`}
                                  style={{ marginBottom: 8 }}
                                  rules={[{ required: !isViewMode, message: 'This field is required' }]}
                                >
                                  <Input placeholder="Enter value" size="small" readOnly={isViewMode} />
                                </Form.Item>
                              </Col>
                              {param.uom && (
                                <Col>
                                  <Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
                                    {param.uom}
                                  </Text>
                                </Col>
                              )}
                            </Row>
                          </Col>
                        ))}
                      </Row>
                    </>
                  )}
                </div>
              );
            })}
          </>
        )}

        <Divider />
        {selectedLabType !== 'VACCINE_MANUFACTURING' && selectedLabType !== 'DIRECT_SALES' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 16 }}>
            <Col span={10}>
              <Form.Item name="results_remarks" label="Result Remarks">
                <TextArea
                  placeholder="Enter result remarks"
                  autoSize={{ minRows: 3, maxRows: 6 }}
                  style={{ marginBottom: 16 }}
                  readOnly={isViewMode}
                />
              </Form.Item>
            </Col>
          </div>
        )}

        <Divider />
        {selectedLabType !== 'VACCINE_MANUFACTURING' && selectedLabType !== 'DIRECT_SALES' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 16 }}>
            <Title level={5}>
              <Text>Lab Report Remarks</Text>
            </Title>
            <Form.Item name="remarks">
              <TextArea
                placeholder="Enter remarks for report"
                autoSize={{ minRows: 4, maxRows: 6 }}
                style={{ marginBottom: 16 }}
                readOnly={isViewMode}
              />
            </Form.Item>
          </div>
        )}

        {!(mode === 'view' && status === 'PENDING_ITRA') && (
          <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 8, marginTop: 16 }}>
            <Button onClick={onClose} size="small">
              {isViewMode ? 'Close' : 'Cancel'}
            </Button>
            {!isViewMode && (
              <Button type="primary" htmlType="submit" size="small" loading={isLoading}>
                Save
              </Button>
            )}
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default ResultsModal;
